import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import { clearSearchBtn } from '../includes/utils';
import CsfFournisseurPagination from "../includes/csf-fournisseur-pagination";

export function CsfPivotalFournisseurAddClient({ clients, currentClients, handleModalAdd }) {

  const [inputSearchValue, setInputSearchValue] = useState('');
  const [availableClients, setAvailableClients] = useState([]);
  const [filteredClients, setFilteredClients] = useState([]);
  const [slicedFilteredClients, setSlicedFilteredClients] = useState([]);
  const [selectedClients, setSelectedClients] = useState([]);
  const [startRow, setStartRow] = useState(1);
  const [total, setTotal] = useState(0);
  const [isSearch, setIsSearch] = useState(false);
  const offset = 8;

  useEffect(() => {
    setInputSearchValue('');

    if (clients && clients.length > 0 && currentClients) {
      setAvailableClients(getAvailableClients);
    }
  }, [clients, currentClients]); // Dependency on clients

  useEffect(() => {
    setTotal(availableClients.length);
    if (availableClients && availableClients.length > 0) {
      setFilteredClients(availableClients);
      setSlicedFilteredClients(availableClients.slice((startRow - 1), (startRow + offset) - 1))
    }
  }, [availableClients]);

  useEffect(() => {
    setSlicedFilteredClients(filteredClients.slice((startRow - 1), (startRow + offset) - 1))
  }, [startRow]);

  useEffect(() => {
    setSlicedFilteredClients(filteredClients.slice((startRow - 1), (startRow + offset) - 1))
    setIsSearch(false);
  }, [isSearch]);

  const getAvailableClients = () => {
    const otherArray = currentClients.map(({label}) => label);
    const available = clients.filter(client => !otherArray.includes(client.label));
    return available;
  };

  const handleSearchChange = (event) => {
    setInputSearchValue(event.target.value);
  };

  const handleSearchBtn = (event) => {
    if (event.key === 'Enter' || event.type === "click") {
      let filtered = availableClients;
      if (inputSearchValue !== '') {
        filtered = availableClients.filter((client) => {
          return client.label.toLowerCase().includes(inputSearchValue.toLowerCase());
        });
      }

      setFilteredClients(filtered);
      setTotal(filtered.length);
      setStartRow(1);
      setIsSearch(true);
    }
  };

  function handleCheckboxChange(event) {
    if (event.target.checked) {
      const checkedClient = availableClients.find(item => item.value === event.target.value);
      setSelectedClients([...selectedClients, checkedClient])
    } else {
      const newArray = selectedClients.filter(item => item.value !== event.target.value);
      setSelectedClients(newArray);
    }
  };

  function resetModal() {
    // Reset the checked inputs
    const inputs = document.querySelectorAll('#AddClient input[name="clientSelected"]:checked');
    if (inputs) {
      inputs.forEach(input => {
        input.click();
      })
    }

    setInputSearchValue('');
    setStartRow(1);
    setFilteredClients(availableClients);
    setTotal(availableClients.length);
    setStartRow(1);
    setIsSearch(true);
    setSelectedClients([]);
  }

  function handleModalSubmit(e) {
    e.preventDefault();
    handleModalAdd(selectedClients);

    setTimeout(() => {
      // Wait for the update of the available notions to reset modal on close
      $("[data-dismiss=modal]").trigger({type: "click"});
    }, 500);
  }

  /*
  * Method that trigger an empty search when X button is clicked in the search field.
  * */
  function retriggerEmptySearch(){
    setInputSearchValue('');
    setFilteredClients(availableClients);
    setTotal(availableClients.length);
    setStartRow(1);
    setIsSearch(true);
  }

  return (
    <div className="modal fade" id="AddClient" tabIndex="-1" role="dialog" aria-labelledby="editFormateurLabel" aria-hidden="true">
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h2 id="editFormateurLabel">
              {window.Drupal.t('fournisseur.creation_form.modal.clients.title')}
            </h2>
            <button type="button" className="close" data-dismiss="modal" aria-label={window.Drupal.t('lang.modal.close')} onClick={resetModal}>
              <i className="icon icon-csf-close-noborder"><span className="d-none">&nbsp;</span></i>
            </button>
          </div>
          <div className="modal-body">

            <div className="modal-list">

              {/* Searchbox - removed in T5537-3297
              <div className="search-container">
                <label htmlFor="addClientSearch" className="sr-only">{window.Drupal.t('fournisseur.creation_form.modal.region.search.placeholder')}</label>
                <input type="search" id="addClientSearch" value={inputSearchValue} onChange={handleSearchChange} onKeyDown={handleSearchBtn}
                  placeholder={window.Drupal.t('fournisseur.creation_form.modal.region.search.placeholder')} />
                <button className="search-close-icon btn-link" aria-label={window.Drupal.t('fournisseur.search.clear.label')}
                  onClick={(e) => {
                    clearSearchBtn(e, setInputSearchValue);
                    retriggerEmptySearch();
                  }}
                >
                  <i className="icon icon-remove"></i>
                </button>
                <button className="button btn-outlined search-icon" onClick={handleSearchBtn}
                  title={window.Drupal.t('search.label')} aria-label={window.Drupal.t('search.label')}>
                  <i className="icon icon-search-2"><span className="d-none">&nbsp;</span></i>
                </button>
              </div>

              <h3>{window.Drupal.t('fournisseur.creation_form.modal.clients.title')}</h3> */}
              <ul>
                {
                  slicedFilteredClients.map((client) => {
                    return !currentClients.some(curClient => curClient.label === client.label) && (
                      <li key={`${client.value}`}>
                        <div className="form-group">
                          <input id={client.value} value={client.value} type="checkbox"
                            name="clientSelected" onChange={handleCheckboxChange}
                            checked={selectedClients.some(curClient => curClient.label === client.label)}/>
                          <label htmlFor={client.value}>{client.label}</label>
                        </div>
                      </li>
                    );
                  })
                }
              </ul>
            </div>

          </div>
          <div className="modal-footer">
            <div className="container space-between-wrapper smaller-wrapper">
              <div className="pagination-wrapper">
              <CsfFournisseurPagination
                startRow={startRow}
                offset={offset}
                total={total}
                setStartRowFunction={setStartRow}
              />
              </div>
              <div className="modal-actions">
                <button type="button" className="button btn-outlined btn-larger" data-dismiss="modal" onClick={resetModal}>
                  {window.Drupal.t('fournisseur.cancel.btn')}
                </button>
                <button type="button" className="button btn-larger" id="modalSaveButton" onClick={handleModalSubmit}>
                  {window.Drupal.t('fournisseur.creation_form.form.add')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

CsfPivotalFournisseurAddClient.propTypes = {
  clients: PropTypes.array.isRequired,
  currentClients: PropTypes.array,
};
